import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AuthenticationService } from './services/authentication-service/authentication.service';
import { UserService } from './services/user-service/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'eDash';

  constructor(private cookie: CookieService, private userService: UserService, private authService: AuthenticationService) {}

  /**
   * On initial app load, check for auth cookie and parse for user data
   */
  ngOnInit(): void {
    const token = this.cookie.get('edash_auth_token');

    if (token) {
      const user = this.authService.parseJwt(token);
      this.userService.saveUser(user);
    }
  }
}
